import React, { useEffect, useState } from "react";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import "../styles/LeadAndExecute.css";
import { format, toZonedTime } from "date-fns-tz";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import axios from "../api/apiClient";
import StartOnboarding from "./StartOnboarding";
import ProjectStatus from "./ProjectStatus";
import { apiUrl } from "../authconfig";
const LeadAndExecute = ({
  currentModalData,
  setCurrentModalData,
  handleClose,
  fetchAllOpportunities,
}) => {
  const [productData, setProductData] = useState([]);
  const [projectPhaseData, setProjectPhaseData] = useState();
  const [isViewMore, setIsViewMore] = useState(false);
  const [editId, setEditId] = useState(null);
  const currentUser = JSON.parse(sessionStorage.getItem("user"));
  const [cancelReason, setCancelReason] = useState();
  const [notInCurrentScopeReason, setNotInCurrentScopeReason] = useState();

  useEffect(() => {
    setIsViewMore(false);
  }, [projectPhaseData]);

  useEffect(() => {
    setProjectPhaseData(currentModalData);
  }, [currentModalData]);

  useEffect(() => {
    if (currentModalData?.projectId) {
      setProjectPhaseData(currentModalData);
      axios
        .get(
          `${apiUrl}/api/productData/getAllById/${currentModalData.projectId}`
        )
        .then((response) => {
          setProductData(response.data);
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
  }, [currentModalData?.projectId]);

  // if (
  //   (projectPhaseData?.projectStatus == 'Cancelled' || projectPhaseData?.projectStatus == 'Not in Current Scope') &&
  //    (projectPhaseData?.estimatedGoLiveDate && projectPhaseData?.estimatedHypercareEndDate && projectPhaseData?.projectStatus)  &&
  //      (projectPhaseData?.projectStatus != 'On track' && projectPhaseData?.detailReasonForNotOnTrack)
  //   )

  const handleSaveClick = (e) => {
    console.log("editId", editId);
    if (editId !== null && editId >= 0) {
      alert("Please save the edited row first in Volume Conversion");
    } else {
      const hasActualGoLiveDate = Boolean(projectPhaseData?.actualGoLiveDate);
      const todayDate = new Date();
      const todayOnly = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate()
      );
      const actualGoLiveDateOnly = hasActualGoLiveDate
        ? new Date(projectPhaseData.actualGoLiveDate)
        : null;

      if (
        actualGoLiveDateOnly &&
        !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
        new Date(
          actualGoLiveDateOnly.getFullYear(),
          actualGoLiveDateOnly.getMonth(),
          actualGoLiveDateOnly.getDate()
        ) > todayOnly
      ) {
        alert("Actual Go-Live Date cannot be a future date.");
        return;
      }

      if (
        projectPhaseData?.projectStatus === "Complete" &&
        !hasActualGoLiveDate
      ) {
        alert(
          "Actual Go-Live Date is mandatory before closing the project."
        );
        return;
      }

      if (
        projectPhaseData?.projectStatus === "Complete" &&
        (!Array.isArray(productData) || productData.length === 0)
      ) {
        alert("Volume Conversion data is mandatory before closing the project.");
        return;
      }

      if (
        projectPhaseData?.projectStatus === "Complete" &&
        productData.some((item) => !String(item?.bookingReference || "").trim())
      ) {
        alert("Booking Reference is mandatory for all products before closing the project.");
        return;
      }

      const hasContactingSalesSelection =
        typeof projectPhaseData?.contactingSales === "boolean";
      const isContactingSalesYes = projectPhaseData?.contactingSales === true;

      if (projectPhaseData?.projectStatus === "Complete" && !hasContactingSalesSelection) {
        alert("Please select whether this project involves contacting Sales for participation.");
        return;
      }

      if (
        projectPhaseData?.projectStatus === "Complete" &&
        isContactingSalesYes &&
        !String(projectPhaseData?.reasonForSalesParticipation || "").trim()
      ) {
        alert("Reason for sales participation is required when contacting Sales is Yes.");
        return;
      }

      if (
        projectPhaseData?.projectStatus === "Complete" &&
        isContactingSalesYes &&
        projectPhaseData?.reasonForSalesParticipation === "Others" &&
        !String(projectPhaseData?.reasonForSalesOther || "").trim()
      ) {
        alert("Please provide details for 'Others' under reason for sales participation.");
        return;
      }

      const agreementStartDate = projectPhaseData?.agreementStartDate
        ? new Date(projectPhaseData.agreementStartDate)
        : null;
      const actualGoLiveDate = actualGoLiveDateOnly;
      const isProjectGoLiveDelayedReasonRequired =
        agreementStartDate &&
        actualGoLiveDate &&
        !Number.isNaN(agreementStartDate.getTime()) &&
        !Number.isNaN(actualGoLiveDate.getTime()) &&
        Math.floor((actualGoLiveDate - agreementStartDate) / (1000 * 60 * 60 * 24)) > 15;

      if (
        isProjectGoLiveDelayedReasonRequired &&
        !String(projectPhaseData?.projectGoLiveDelayedReason || "").trim()
      ) {
        alert(
          "Project go-live delayed reason is required when Actual Go-Live Date is more than 15 days after Agreement Start Date."
        );
        return;
      }
      
      if (
        (projectPhaseData?.projectStatus === "Cancelled" && !cancelReason) ||
        (projectPhaseData?.projectStatus === "Not in Current Scope" &&
          !notInCurrentScopeReason)
      ) {
        alert("Please select a further reason for the current project status selected.");
        return;
      }
      if (
        projectPhaseData?.projectStatus != "Complete" ||
        (projectPhaseData?.projectStatus == "Complete" &&
          productData?.every(
            (item) =>
              (item?.averageActualWeeklyVolume / item?.scheduledWeeklyVolume >
                0.8 ||
                item.commentsOnLowVolume) &&
              item?.averageActualWeeklyVolume
          ))
      ) {
        axios
          .post(
            `${apiUrl}/api/opportunities/save`,
            {
              ...projectPhaseData,
              projectGoLiveDelayedReason: isProjectGoLiveDelayedReasonRequired
                ? projectPhaseData?.projectGoLiveDelayedReason
                : "",
              fullOnboarding: true,
              liteOnboarding: false,
              modifiedBy: currentUser?.mail,
              projectSubstatus:
                projectPhaseData?.projectStatus === "Cancelled"
                  ? cancelReason
                  : projectPhaseData?.projectStatus === "Not in Current Scope"
                  ? notInCurrentScopeReason
                  : null,
              modifiedDate: format(
                toZonedTime(new Date(), "Europe/Copenhagen"),
                "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"
              ),
            }
          )
          .then((response) => {
            console.log(response);
            setCurrentModalData({
              ...projectPhaseData,
            });
            alert("Data saved successfully");
            handleClose();
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 403) {
                alert("Please fill all mandatory fields");
              } else if (error.response.status === 400) {
                alert(error.response.data || "Bad request");
              } else {
                alert("An error occurred. Please try again.");
              }
              console.log("error", error);
            } else {
              alert("An error occurred. Please try again.");
              console.log("error", error);
            }
          });
      } else {
        alert("Please fill up both values in the Volume Converion Table");
      }
    }
  };

  return (
    <div>
      <div className="Project" style={{ color: "rgb(0, 36, 61)" }}>
        Project Details
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "25px",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Project ID</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.projectId || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Closed Won Date</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.closedWonDate || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Opportunity Reference</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.opportunityReference || ""}
            ></McInput>
          </div>
        </div>
        <div style={{ display: "flex", width: "25%" }}>
          <div className="DetailsLabel">Account Name</div>
          <div className="DetailsLabel">
            <McInput
              className="inputReadonly"
              hiddenlabel="true"
              fit="small"
              readonly={true}
              value={currentModalData?.accountName || ""}
            ></McInput>
          </div>
        </div>
      </div>
      {!isViewMore && (
        <div
          style={{
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setIsViewMore(true)}
        >
          <AddIcon />
          View More
        </div>
      )}
      {isViewMore && (
        <>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "25px",
              justifyContent: "space-between",
              paddingTop: "10px",
            }}
          >
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Product Family</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.productBundles || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Opportunity Type</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.opportunityType || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Country Role</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.countryRole || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Agreement Start Date</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.agreementStartDate || ""}
                ></McInput>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "25px",
              justifyContent: "space-between",
              paddingTop: "10px",
            }}
          >
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Agreement End Date</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.agreementEndDate || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Gross Profit (USD)</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.grossProfit || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Total Revenue</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.totalRevenue || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Executing Country</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.executingCountry || ""}
                ></McInput>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "25px",
              justifyContent: "space-between",
              paddingTop: "10px",
            }}
          >
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Opportunity Owner Country</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.opportunityOwnerCountry || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Service Contract Number</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.serviceContractNumber || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Customer SCV code</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.customerScvCode || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Opportunity Name</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.opportunityName || ""}
                ></McInput>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "25px",
              justifyContent: "space-between",
              paddingTop: "10px",
            }}
          >
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Opportunity Owner</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.opportunityOwner || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Closed Won Date</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.closedWonDate || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Vertical</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.vertical || ""}
                ></McInput>
              </div>
            </div>
            <div style={{ display: "flex", width: "25%" }}>
              <div className="DetailsLabel">Brand</div>
              <div className="DetailsLabel">
                <McInput
                  className="inputReadonly"
                  hiddenlabel="true"
                  fit="small"
                  readonly={true}
                  value={currentModalData?.brand || ""}
                ></McInput>
              </div>
            </div>
            {/* <div style={{ display: "flex", width: "25%" }}></div> */}
          </div>
        </>
      )}
      {isViewMore && (
        <div
          style={{
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setIsViewMore(false)}
        >
          <RemoveIcon />
          View Less
        </div>
      )}
      <div className="Project"></div>
      <div className="Project">
        <div style={{ display: "flex", gap: "10px", paddingTop: "10px" }}>
          <div style={{ width: "40%" }}>
            <div
              className="ProjectTitle"
              style={{
                color: "rgb(0, 36, 61)",
                position: "sticky",
                top: 0,
                background: "white",
                borderBottom: "1px solid #ccc",
                zIndex: "1",
              }}
            >
              Project Phase Progress
            </div>
            <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
              <div style={{ fontFamily: "Maersk Text", fontSize: "14px" }}>
                <StartOnboarding
                  projectPhaseData={projectPhaseData}
                  setProjectPhaseData={setProjectPhaseData}
                  productData={productData}
                  editId={editId}
                  handleSaveClick={handleSaveClick}
                  currentModalData={currentModalData}
                  handleClose={handleClose}
                  setCurrentModalData={setCurrentModalData}
                />
              </div>
            </div>
          </div>
          <div style={{ width: "60%" }}>
            <div
              style={{
                color: "rgb(0, 36, 61)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                position: "sticky",
                top: 0,
                background: "white",
                borderBottom: "1px solid #ccc",
                zIndex: "100",
              }}
            >
              <div className="ProjectTitle">Project Status </div>{" "}
              <div style={{ textAlign: "right" }}>
                <Button
                  className="closePhaseButton"
                  style={{
                    padding: "0 10px",
                    width: "max-content",
                    backgroundColor: "rgb(0, 36, 61)",
                    position: "sticky",
                  }}
                  variant="contained"
                  onClick={(e) => handleSaveClick(e)}
                  disabled={
                    currentModalData?.projectStatus == "Cancelled" ||
                    currentModalData?.projectStatus == "Not in Current Scope" ||
                    currentModalData?.projectStatus == "Complete" ||
                    currentModalData?.assignedUser != currentUser?.mail
                  }
                >
                  Save Details
                </Button>
              </div>
            </div>
            <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
              <ProjectStatus
                projectPhaseData={projectPhaseData}
                setProjectPhaseData={setProjectPhaseData}
                productData={productData}
                setProductData={setProductData}
                currentModalData={currentModalData}
                editId={editId}
                setEditId={setEditId}
                cancelReason={cancelReason}
                setCancelReason={setCancelReason}
                notInCurrentScopeReason={notInCurrentScopeReason}
                setNotInCurrentScopeReason={setNotInCurrentScopeReason}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Product Table */}
      {/* <TableContainer component={Paper}>
        <Table sx={{ fontFamily: 'Maersk Text' }}>
          <TableHead>
            <TableRow>
              <TableCell>Project ID</TableCell>
              <TableCell>Product Family</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Total Quantity</TableCell>
              <TableCell>Unit of Measure (UOM)</TableCell>
              <TableCell>Gross Profit</TableCell>
              <TableCell>Revenue</TableCell>
              <TableCell>Scheduled Weekly Volume</TableCell>
              <TableCell>Average Actual Weekly Volume</TableCell>
              <TableCell>Comments on Low Volume</TableCell>
              <TableCell>Executing Country</TableCell>
              <TableCell>Opportunity Reference</TableCell>
              <TableCell>Date Added</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productData.map((product, index) => (
              <TableRow key={index}>
                <TableCell>{product.projectId}</TableCell>
                <TableCell>{product.productFamily}</TableCell>
                <TableCell>{product.product}</TableCell>
                <TableCell>{product.totalQuantity}</TableCell>
                <TableCell>{product.uom}</TableCell>
                <TableCell>{product.productGrossProfit}</TableCell>
                <TableCell>{product.productRevenue}</TableCell>
                <TableCell>{product.scheduledWeeklyVolume}</TableCell>
                <TableCell>{product.averageActualWeeklyVolume}</TableCell>
                <TableCell>{product.commentsOnLowVolume}</TableCell>
                <TableCell>{product.opportunityReference}</TableCell>
                <TableCell>{product.dateAdded}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
    </div>
  );
};

export default LeadAndExecute;
